<template>
 <div class="line-item"> 
      <div class="heading ml-2" style="display:flex;">        
        <v-btn class="adminLibelleBtn" :to="{name:`Edit${itemTypeName}`,params:{itemid:item.id}}" flat :title="$t(`Admin.${itemTypeName}.List.Reach${itemTypeName}Tooltip`)" >{{item.libelle}}</v-btn>
      </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbBase } from '@/models/alodb/AloDbBase';


@Component({
  name: 'AdminListLine',   
   props: {  
     item:{
       type:AloDbBase,
       required:true
     },
     itemTypeName:String
  }
})
export default class AdminListLine extends Vue {
  item!:AloDbBase  
  itemTypeName!:string
}
</script>

<style>
  .adminLibelleBtn {
    flex:1 0 auto;    
  }
  .adminLibelleBtn .v-btn__content{
    justify-content:flex-start;
  }
</style>